import React, { useEffect, useState } from "react";
import "./BackToTop.css";
import { FaArrowUp } from "react-icons/fa";

const BackToTop = () => {
  const [isvisible, setisvisible] = useState(false);

  const handlescroll = () => {
    if (window.pageYOffset > 300) {
      setisvisible(true);
    } else {
      setisvisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handlescroll);
    return () => {
      window.removeEventListener("scroll", handlescroll);
    };
  });
  const scrolltotop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="backto">
      {isvisible && (
        <button className="back" onClick={scrolltotop}>
          <FaArrowUp />
        </button>
      )}
    </div>
  );
};

export default BackToTop;
